<ng-container *ngIf="!isReforma">
  <div class="faq-section">
    <h2>{{ titleFaq }}</h2>
    <p *ngIf="subTitleFaq">{{ subTitleFaq }}</p>
    <div class="faq-section-card" *ngFor="let item of faqs; let i = index">
      <button type="button" [id]="'faq-item-' + i + '-' + getTipoFaqs" (click)="toggleFaq(i)" class="faq-item"
        [ngClass]="{ open: item.isOpen }">
        <div class="question">
          {{ item.question }}
          <div class="question-icon">
            <ion-icon class="arrow" [class.open]="item.isOpen" name="chevron-down-outline"></ion-icon>
          </div>
        </div>
      </button>
      <div class="answer" *ngIf="item.isOpen">
        <p class="answer1" [innerHTML]="item.answer1"></p>
        <p *ngIf="item.answer2" [innerHTML]="item.answer2"></p>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isReforma">
  <div class="faq-section">
    <h2>{{ titleFaq }}</h2>
    <p *ngIf="subTitleFaq">{{ subTitleFaq }}</p>
    <div class="faq-section-card" *ngFor="let item of faqs; let i = index">
      <button type="button" [id]="'faq-item-' + i + '-' + getTipoFaqs" (click)="toggleFaq(i)" class="faq-item"
        [ngClass]="{ open: item.isOpen }">
        <div class="question">
          {{ item.question }}
          <div class="question-icon">
            <ion-icon class="arrow" [class.open]="item.isOpen" name="chevron-down-outline"></ion-icon>
          </div>
        </div>
      </button>
      <div [id]="'faq-answer-' + i" class="answer" *ngIf="item.isOpen">
        <ng-container *ngIf="tipoBeneficio === 'PGU'">
          <ng-container *ngIf="(item?.pguAnswer?.length ?? 0) > 0">
            <div class="pguAnswer">
              <div class="pguAnswer__title">
                <p>{{item.answer1}}</p>
              </div>
              <ng-container *ngIf="item.imagen">
                <img [src]="item.imagen" alt="">
              </ng-container>
              <div class="margin-botton-20" *ngFor="let step of item.pguAnswer">
                <ul>
                  <li>
                    <strong>{{ step.date }}</strong>
                    <ul>
                      <li *ngFor="let detail of step.details">
                        {{detail}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="(item?.pguAnswer2?.length ?? 0) > 0">
            <div class="pguAnswer2">
              <div class="pguAnswer2__start">
                <p style="margin-top: 0;">{{item.answer1}}</p>
              </div>
              <ng-container *ngIf="item.imagen">
                <img [src]="item.imagen" alt="">
              </ng-container>
              <ul>
                <li *ngFor="let item of item.pguAnswer2" [innerHTML]="item.condition"></li>
              </ul>
              <div class="pguAnswer2__start">
                <p><strong>Importante:</strong> para solicitar la PGU, debes cumplir con los requisitos establecidos.
                </p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="(item?.pguAnswer3)">
            <p style="margin-top: 0;">{{item.pguAnswer3}} <a (click)="goToChileAtiende()" class="link">ChileAtiende</a>.
              En este mismo sitio, también podrás saber si
              accederás al beneficio con las modificaciones de la Reforma de Pensiones.</p>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="tipoBeneficio === 'BAC' || tipoBeneficio === 'CEV'">

          <ng-container>
            <div>
              <p *ngIf="item.answer1" class="no-margin-important">{{ item.answer1 }}</p>
            </div>

          </ng-container>
        </ng-container>

        <ng-container *ngIf="tipoBeneficio === 'UF_RETIRO_PROGRAMADO'">
          <ng-container *ngIf="(item?.pguAnswer?.length ?? 0) > 0">
            <div style="gap: 0;" class="pguAnswer">
              <div class="pguAnswer__start">
                <p class="margin-0">{{item.answer1}}</p>
              </div>
              <div>
                <ul>
                  <li *ngFor="let step of item.pguAnswer">
                    {{step}}
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="item.imagen && item?.pguAnswer">
                <img [src]="item.imagen" alt="">
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngIf="(item?.pguAnswer2)">
            <div class="pguAnswer2">
              <p class="margin-0">{{item.pguAnswer2}}</p>
            </div>
          </ng-container>

          <ng-container *ngIf="(item?.pguAnswer3?.length ?? 0) > 0">
            <div class="pguAnswer3" style="gap: 0;">
              <div class="pguAnswer3__start">
                <p class="margin-0">{{item.answer1}}</p>
              </div>
              <div>
                <ul>
                  <li *ngFor="let step of item.pguAnswer3">
                    {{step}}
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="item.imagen">
                <img [src]="item.imagen" alt="">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>
  </div>
</ng-container>